import type { ChangePasswordInput, LoginInput } from '@oficina/shared';
import { api } from '@/lib/api';
import type { User } from '@/types/api';

export const authService = {
  me: () => api.get<User>('/auth/me'),
  login: (input: LoginInput) => api.post<{ user: User; expiresAt: string }>('/auth/login', input),
  logout: () => api.post<void>('/auth/logout'),
  changePassword: (input: ChangePasswordInput) => api.patch<void>('/auth/me/password', input),
};
